import { createTheme, ThemeOptions, PaletteOptions } from "@mui/material";
import { colors } from "../constants/colors";

declare module "@mui/material/styles" {
  interface BreakpointOverrides {
    xs: true;
    sm: true;
    md: true;
    lg: true;
    xl: true;
    mobile: true;
    mobileXl: true;
    tablet: true;
    tabLetXl: true;
    desktop: true;
    desktopXl: true;
  }
}
declare module "@mui/material/styles" {
  interface Palette {
    subPrimary: Palette["primary"];
  }
  interface PaletteOptions {
    subPrimary?: PaletteOptions["primary"];
  }
}

export const theme: ThemeOptions = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
      mobile: 320,
      mobileXl: 640,
      tablet: 768,
      tabLetXl: 1024,
      desktop: 1440,
      desktopXl: 1920,
    },
  },
  palette: {
    subPrimary: {
      main: "#FCAF17",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        outlined: {
          border: '1px solid #4A4A4A',
          color: "#4A4A4A",
          '&:hover': {
            border: '1px solid #4A4A4A',
          }
        },
        containedSuccess: {
          backgroundColor: "#0F9F0C",
          borderRadius: "8px",
          '&:hover': {
            backgroundColor: "#0F9F0C",
          }
        },
        containedError: {
          borderRadius: "8px",
          color: colors.white
        },
        containedSecondary: {
          borderRadius: "8px",
          backgroundColor: "#F79009",
          '&:hover': {
            backgroundColor: "#F79009",
          }
        },
        colorSecondary: {
          color: "#F79009"
        }
      }
    }
  },
  typography: {
    body1: {
      fontSize: "16px",
      fontWeight: "400",
      lineHeight: "23.92px",
      color: "#4A4A4A",
    },
    // heading shape
    subtitle1: {
      fontSize: "14px",
      fontWeight: "300",
      lineHeight: "21px",
    },
    // heading bold
    subtitle2: {
      fontSize: "14px",
      fontWeight: "100",
      lineHeight: "23.92px",
    },
    h1: {
      fontSize: "56px",
      fontWeight: "500",
      // color: "#4A4A4A",
    },
    h2: {
      fontSize: "48px",
      fontWeight: "500",
      // color: "#4A4A4A",
    },
    h3: {
      fontSize: "36px",
      fontWeight: "500",
      // color: "#4A4A4A",
    },
    h4: {
      fontSize: "28px",
      fontWeight: "500",
      // color: "#4A4A4A",
    },
    h5: {
      fontSize: "24px",
      fontWeight: "500",
      // color: "#4A4A4A",
    },
    h6: {
      fontSize: "16px",
      fontWeight: "600",
      // color: "#4A4A4A",
    },
  },
});
